import FooterBar from '@/components/navbar/FooterBar';
import PinGuideTextArea from './components/PinGuideTextArea';
import PinIndicator from './components/PinIndicator';
import PinNumberPad from './components/PinNumberPad';
import usePin from './usePin';

const Pin = () => {
  const { pin, isPinCheckFailed, onClickNumberBtn, OnClickDeleteBtn, onClickAllClearBtn } = usePin();
  return (
    <div className="wrap wrap_temporary pin join-pin">
      <div className="container" style={{ marginTop: '17rem' }}>
        <h2 className="fw-b">{'PIN 비밀번호 입력'}</h2>
        <p className="body-s-n fw-b">{isPinCheckFailed ? '다시 한번 입력해주세요.' : ''}</p>
        <PinIndicator pin={pin} />
        <PinGuideTextArea isPinCheckFailed={isPinCheckFailed} />
        <PinNumberPad
          onClickNumberBtn={onClickNumberBtn}
          OnClickDeleteBtn={OnClickDeleteBtn}
          onClickAllClearBtn={onClickAllClearBtn}
        />
      </div>
      <FooterBar />
    </div>
  );
};

export default Pin;
